<h1 mat-dialog-title>{{ title() }}</h1>
<div mat-dialog-content>
  @if (data.optionalData?.deleteMode) {
    <p class="dialog-text">
      Weet je zeker dat je deze actie wilt uitvoeren?
      @if (itemName()) {
        {{ type() ? type() + ': ' : '' }}
        <b>{{ itemName() }}</b>
        wordt definitief verwijderd.
      }
    </p>
  }
  @if (!data.optionalData?.deleteMode) {
    <div>
      @if (usesHtml()) {
        <p class="warning-text" [innerHTML]="text()"></p>
      } @else {
        <p class="warning-text">{{ text() }}</p>
      }
    </div>
  }
  @if (notification()) {
    @if (usesHtml()) {
      <div class="notification" [innerHTML]="notification()"></div>
    } @else {
      <p class="notification">
        {{ notification() }}
      </p>
    }
  }
  @if (data.optionalData?.sepaMandateId) {
    <p class="focused-data-center">
      {{ data.optionalData?.sepaMandateId }}
    </p>
  }
  @if (data.optionalData?.failedAddresses) {
    <div class="failed-addresses-container">
      <div class="failed-addresses-list">
        @for (failedAddress of data.optionalData.failedAddresses; track $index) {
          <div class="failed-address-item">
            <p class="failed-address-name">
              <b>{{ failedAddress.name }}</b>
            </p>
            <p class="failed-address-address">{{ failedAddress.address }}</p>
            <p class="failed-address-error">{{ failedAddress.error }}</p>
          </div>
        }
      </div>
    </div>
  }
  @if (data.optionalData?.failedRows) {
    <div class="failed-addresses-container">
      <div class="failed-addresses-list">
        @for (failedRow of data.optionalData.failedRows; track $index) {
          <div class="failed-address-item">
            <p class="failed-address-name">
              <b>{{ failedRow.name }}</b>
            </p>
            @if (failedRow.address) {
              <p class="failed-address-address">{{ failedRow.address }}</p>
            }
            <p class="failed-address-error">{{ failedRow.error }}</p>
          </div>
        }
      </div>
    </div>
  }

  @if (data.dialogType === 'addressLowConfidence' && getMapsLink()) {
    <div class="maps-button-wrapper">
      <a mat-flat-button class="secondary-color" [href]="getMapsLink()" target="_blank" rel="noopener noreferrer">
        Controleren in Google Maps
      </a>
    </div>
  }
</div>
<div mat-dialog-actions>
  @if (data.optionalData?.deleteMode) {
    <button mat-button class="error-color" [mat-dialog-close]="true">
      <mat-icon class="error-color">delete</mat-icon>
      Ja, verwijderen
    </button>
  }
  @if (data.optionalData?.deleteMode) {
    <button mat-flat-button [mat-dialog-close]="false">Nee, niet verwijderen</button>
  }
  @if (data.optionalData?.thirdButtonText) {
    <button
      mat-button
      [class]="data.optionalData?.thirdButtonClass"
      [mat-dialog-close]="data.optionalData?.thirdButtonValue"
    >
      @if (data.optionalData?.thirdButtonIcon) {
        <mat-icon [class]="data.optionalData?.thirdButtonClass">{{ data.optionalData?.thirdButtonIcon }}</mat-icon>
      }
      {{ data.optionalData?.thirdButtonText }}
    </button>
  }
  @if (!data.optionalData?.deleteMode && confirmDialog()) {
    <button mat-button [mat-dialog-close]="confirmButtonValue()" class="error-color">
      {{ acceptButtonText() }}
    </button>
  }
  @if (!data.optionalData?.deleteMode) {
    <button mat-flat-button [mat-dialog-close]="false">
      {{ confirmDialog() ? denyButtonText() : 'Sluiten' }}
    </button>
  }
</div>
